import api from './api.ts';
import {resolveMembersBaseUrl} from './membersApi.ts';

export const MARKETING_CONSENT_VERSION = '2026-09-12-v1';
export interface MarketingPreference {
  enabled: boolean;
  revision: number;
  consent_version: string;
  suppressed: boolean;
}
export interface MemberEmailDelivery {
  id: string;
  partner_id: number;
  kind: string;
  status: string;
  event_status: string | null;
  created_at: string;
  sent_at: string | null;
  error_code: string | null;
}
const base = '/api/members';
const connection = () => ({baseURL: resolveMembersBaseUrl(window.location)});
export const membersEmailApi = {
  requestReset: async (email: string) => (await api.post<{message: string}>(`${base}/password-reset/request`, {email}, connection())).data,
  confirmReset: async (token: string, password: string) => (await api.post<{message: string}>(`${base}/password-reset/confirm`, {token, password}, connection())).data,
  preference: async () => (await api.get<MarketingPreference>(`${base}/marketing-preference`, connection())).data,
  savePreference: async (preference: Pick<MarketingPreference, 'enabled' | 'revision' | 'consent_version'>, csrfToken: string) => (await api.put<MarketingPreference>(`${base}/marketing-preference`, preference, {...connection(), headers: {'X-Members-CSRF': csrfToken}})).data,
  history: async (offset = 0) => (await api.get<{items: MemberEmailDelivery[]; total: number}>(`${base}/admin/email-history`, {params: {limit: 25, offset}})).data,
};
